<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <div class="tasklist">
          <div>
            <el-button
              size="medium"
              type="primary"
              @click="dialogFormVisible = true">添加</el-button>
            <el-dialog
              width="30%"
              title="添加材料"
              :visible.sync="dialogFormVisible">
              <el-form :model="formData">
                <el-row>
                  <el-col :span="10">
                    <el-form-item>
                      任务名称（前台）：
                    </el-form-item>
                  </el-col>
                  <el-col :span="14">
                    <el-form-item>
                      <el-input v-model="formData.foregroundTask"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-form-item>
                      任务名称（后台）：
                    </el-form-item>
                  </el-col>
                  <el-col :span="14">
                    <el-form-item>
                      <el-input v-model="formData.backgroundTask"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="foot">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item>
                        <el-button
                          type="primary"
                          class="el-btn-save"
                          @click="addTaskTpl">保存
                        </el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <el-button
                          @click="clearForm"
                          class="el-btn-cancel">重置</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </el-dialog>
          </div>
          <div class="basic-title"><em>{{ countryName }}材料列表</em></div>
        </div>
        <el-table
          class="tableList"
          border
          :data="tableData"
          style="width: 100%">
          <el-table-column
            label="任务名称（后台）"
            prop="backstage"
          />
          <el-table-column
            label="任务名称（前台）"
            prop="foreground"
          />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <router-link
                target="_blank"
                :to="{ name: 'taskEdit',params: { country: country,taskId:scope.row.id}}">
                <el-button
                  size="mini"
                  type="info">编辑</el-button>
              </router-link>

              <router-link
                target="_blank"
                :to="{ name: 'taskExample',params: { country: country,taskId:scope.row.id}}">
                <el-button
                  size="mini"
                  type="success">例子</el-button>
              </router-link>

              <router-link
                target="_blank"
                :to="{ name: 'taskVideo',params: { country: country,taskId:scope.row.id}}">
                <el-button
                  size="mini"
                  type="primary">视频说明</el-button>
              </router-link>

              <el-button
                size="mini"
                type="danger"
                @click="isdeleteTaskTpl(scope.row)">删除
              </el-button>
              <el-dialog
                title="提示"
                :visible.sync="deleteDialogVisible"
                width="30%">
                <span>你确定删除“{{ deleteInfo }}”</span>
                <span
                  slot="footer"
                  class="dialog-footer">
                  <el-button @click="deleteDialogVisible = false">取 消</el-button>
                  <el-button
                    type="primary"
                    @click="deleteTaskTpl">确 定</el-button>
                </span>
              </el-dialog>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<style scoped>

    .el-btn-save {
        background: #5daf34;
        border-color: #5daf34;
        color: #fff;
        float: right;
        margin-right: 10px;
    }

    .el-btn-save:hover {
        opacity: 0.8;
    }

    .el-btn-cancel {
        background: #ebb563;
        border-color: #ebb563;
        color: #fff;
        margin-left: 10px;
    }

    .el-btn-cancel:hover {
        opacity: 0.8;
    }

    .tableList .el-table th {
        background-color: #01142d;
        height: 20px;
        line-height: 20px;
    }
</style>
<style>
    .tableList .has-gutter th {
        background: #01142d;
    }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';

export default {
  data() {
    return {
      countryName: '',
      taskId: '',
      deleteInfo: '',
      dialogFormVisible: false,
      deleteDialogVisible: false,
      formData: {
        foregroundTask: '',
        backgroundTask: '',
      },
      tableData: [{
        foreground: '2',
        backstage: '3',
        action: '4'
      }],
      country: null
    };
  },
  components: {
    'jm-crumbs': crumbs,
  },
  methods: {
    isdeleteTaskTpl(row) {
      this.deleteDialogVisible = true;
      this.deleteInfo = row.foreground;
      this.taskId = row.id;
      console.log(row);
    },
    deleteTaskTpl() {
      this.$http
        ._post({
          url: '/index/Task/deleteTaskTpl',
          data: { taskId: this.taskId },
        })
        .then((data) => {
          this.deleteDialogVisible = false;
          if (data.result === 0) {
            this.$message.success('删除成功！');
            this.getForeAndBackstage();
          } else {
            this.$message.error('删除失败！');
          }
        });
    },
    addTaskTpl() {
      let country = this.$route.params.country;
      if (this.formData.backgroundTask.trim() === '') {
        this.$message.error('请输入后台任务名称！');
        return;
      }
      if (this.formData.foregroundTask.trim() === '') {
        this.$message.error('请输入前台任务名称！');
        return;
      }
      this.$http._post({
        url: `/index/Task/addTaskTpl?backgroundTask=${this.formData.backgroundTask}&foregroundTask=${this.formData.foregroundTask}&country=${country}`,
      }).then((data) => {
        console.log(data);
        if (data.result === 0) {
          this.dialogFormVisible = false;
          this.$message.success('添加成功，请点击编辑输入详细信息！');
          this.getForeAndBackstage();
          this.clearForm();
        }
      }).catch(() => {
        this.clearForm();
      });
    },
    clearForm() {
      this.formData.foregroundTask = '';
      this.formData.backgroundTask = '';
    },
    getForeAndBackstage() {
      let country = this.$route.params.country;
      switch (country) {
        case 'uk':
          this.countryName = '英国';
          break;
        case 'aus':
          this.countryName = '澳洲';
          break;
        case 'jp':
          this.countryName = '日本';
          break;
        case 'usa':
          this.countryName = '美国';
          break;
        case 'qiancheng_jp':
          this.countryName = '前程日本';
          break;
        case 'qiancheng_lang':
          this.countryName = '前程语言';
          break;
        case 'all':
          this.countryName = '全集';
          break;
        default:
          this.countryName = '';
      }
      this.$http._get({
        url: `/index/Task/getForeAndBackstage?country=${this.country}`
      }).then(({ data }) => {
        console.log(data);
        this.tableData = data;
      });
    },
  },
  mounted() {
    this.country = this.$route.params.country;
    this.getForeAndBackstage();
  }
};
</script>
